import { UserEditPage } from "~/domain/common";

export function DsmUserEditPage() {
  return <UserEditPage />;
}
